/* eslint-disable import/prefer-default-export */
export const uploadCSV = (multipartFormData, token) => ({
  type: 'UPLOAD_CSV',
  payload: {
    multipartFormData,
    token,
  },
});


export const getGameLiveStreams = (gameId, token) => ({
  type: 'GET_GAMES_LIVE_STREAMS',
  payload: {
    gameId,
    token,
  },
});

export const getGameBountiesData = (gameId, token) => ({
  type: 'GET_GAME_BOUNTIES_DATA',
  payload: {
    gameId,
    token,
  },
});

export const getAUserList = (pageNum, filter, sorting, token, exactMatch) => ({
  type: 'GET_A_USER_LIST',
  payload: {
    pageNum,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getAUserListCsv = (pageNum, filter, sorting, token) => ({
  type: 'GET_A_USER_LIST_CSV',
  payload: {
    pageNum,
    filter,
    sorting,
    token,
  },
});

export const getAUser = (userId, token) => ({
  type: 'GET_A_USER',
  payload: {
    userId,
    token,
  },
});

export const createAUser = (user, token) => ({
  type: 'CREATE_A_USER',
  payload: {
    user,
    token,
  },
});

export const createAUserBrand = (user, token) => ({
  type: 'CREATE_A_USER_BRAND',
  payload: {
    user,
    token,
  },
});

export const updateAUser = (userId, user, token) => ({
  type: 'UPDATE_A_USER',
  payload: {
    userId,
    user,
    token,
  },
});

export const getAConfigList = token => ({
  type: 'GET_A_CONFIG_LIST',
  payload: {
    token,
  },
});

export const getAConfig = (configId, token) => ({
  type: 'GET_A_CONFIG',
  payload: {
    configId,
    token,
  },
});

export const createAConfig = (config, token) => ({
  type: 'CREATE_A_CONFIG',
  payload: {
    config,
    token,
  },
});

export const updateAConfig = (config, token) => ({
  type: 'UPDATE_A_CONFIG',
  payload: {
    config,
    token,
  },
});

export const getAdminQuestListByGame = (gameId, token) => ({
  type: 'GET_ADMIN_QUEST_LIST_BY_GAME',
  payload: {
    gameId,
    token,
  },
});

export const getAGameList = (token) => ({
  type: 'GET_A_GAME_LIST',
  payload: {
    token,
  },
});

export const getAGame = (gameId, token) => ({
  type: 'GET_A_GAME',
  payload: {
    gameId,
    token,
  },
});

export const createAGame = (game, token) => ({
  type: 'CREATE_A_GAME',
  payload: {
    game,
    token,
  },
});

export const updateAGame = (gameId, game, token) => ({
  type: 'UPDATE_A_GAME',
  payload: {
    gameId,
    game,
    token,
  },
});

export const createAPlatform = (platform, token) => ({
  type: 'CREATE_A_PLATFORM',
  payload: {
    platform,
    token,
  },
});

export const getAllPlatforms = token => ({
  type: 'GET_ALL_PLATFORMS',
  payload: {
    token,
  },
});

export const updateAFeatured = (featuredGames, token) => ({
  type: 'UPDATE_A_FEATURED',
  payload: {
    featuredGames,
    token,
  },
});

export const requestUploadImageUrl = (slug, format, token, uploadContext = {}) => ({
  type: 'REQUEST_UPLOAD_IMAGE_URL',
  payload: {
    slug,
    format,
    token,
    uploadContext,
  },
});

export const getATrackedGames = token => ({
  type: 'GET_A_TRACKED_GAMES',
  payload: {
    token,
  },
});

export const getACampaign = (campaignId, token) => ({
  type: 'GET_A_CAMPAIGN',
  payload: {
    campaignId,
    token,
  },
});

export const getACampaignList = token => ({
  type: 'GET_A_CAMPAIGN_LIST',
  payload: {
    token,
  },
});

export const getACampaignQuestsReport = (campaignId, token) => ({
  type: 'GET_A_CAMPAIGN_QUESTS_REPORT',
  payload: {
    campaignId,
    token,
  },
});

export const getAPaymentList = (pageNum, filter, sorting, token) => ({
  type: 'GET_A_PAYMENT_LIST',
  payload: {
    pageNum,
    filter,
    sorting,
    token,
  },
});

export const getAPaymentListCsv = (pageNum, filter, sorting, token) => ({
  type: 'GET_A_PAYMENT_LIST_CSV',
  payload: {
    pageNum,
    filter,
    sorting,
    token,
  },
});

export const getPaypalPayments = token => ({
  type: 'GET_PAYPAL_PAYMENTS',
  payload: {
    token,
  },
});

export const getAQuestList = token => ({
  type: 'GET_A_QUEST_LIST',
  payload: {
    token,
  },
});

export const getInsightsData = (filters, timeData, token) => ({
  type: 'GET_INSIGHTS_DATA',
  payload: {
    filters,
    timeData,
    token,
  },
});

export const getInsightsOptions = token => ({
  type: 'GET_INSIGHTS_OPTIONS',
  payload: {
    token,
  },
});

export const createOffPlatformUser = (twitchLogin, email, paymentEmail, first, last, token) => ({
  type: 'CREATE_OFF_PLATFORM',
  payload: {
    twitchLogin, email, paymentEmail, first, last, token,
  },
});

export const getRollOutRecord = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_OUT_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollOutCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_OUT_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const approveRollOut = (orderId,approveType, token) => ({
  type: 'APPROVE_ROLL_OUT',
  payload: {
    orderId,
    approveType,
    token,
  },
});

export const getRollOutRecordAdmin = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_OUT_LIST_ADMIN',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollInRecordAdmin = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_IN_LIST_ADMIN',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollInCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_IN_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollOutAll = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_OUT_ALL',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const showRollOutPay = (orderId, token) => ({
  type: 'GET_ROLL_OUT_PAY_ORDER',
  payload: {
    orderId,
    token,
  },
});

export const getQuestLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_QUEST_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getQuestLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_QUEST_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getProfileLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_PROFILE_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getProfileLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_PROFILE_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getWalletLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_WALLET_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getWalletLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_WALLET_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getCDKeyLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_CDKEY_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getCDKeyLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_CDKEY_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getDailyTaskLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_DAILY_TASK_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getDailyTaskLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_DAILY_TASK_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getChannelLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_CHANNEL_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getChannelLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_CHANNEL_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getOtherLog = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_OTHER_LOG',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getOtherLogCsv = (pageNum,search, filter, sorting, token,type) => ({
  type: 'GET_OTHER_LOG_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    type
  },
});

export const getLogSummary = (token) => ({
  type: 'GET_LOG_SUMMARY',
  payload: {
    token
  },
});

export const createRegion = (region,canAdd, token) => ({
  type: 'CREATE_REGION',
  payload: {
    region,
    canAdd,
    token,
  },
});

export const getRegions = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_REGIONS',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getAllRegions = (token) => ({
  type: 'GET_ALL_REGIONS',
  payload: {
    token,
  },
});

export const createRegions = (regions, token) => ({
  type: 'CREATE_REGIONS',
  payload: {
    regions,
    token,
  },
});

export const updateRegion = (regionId,regionName,active,country,countryConfirm, token) => ({
  type: 'UPDATE_REGION',
  payload: {
    regionId,
    regionName,
    active,
    country,
    countryConfirm,
    token,
  },
});

export const updateRegions = (regions, token) => ({
  type: 'UPDATE_REGIONS',
  payload: {
    regions,
    token
  },
});

export const getCDKOrderRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_ORDERS_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKOrderRecordsCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_ORDERS_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getPermissions = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_PERMISSIONS',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const updatePermissions = (permissions, token) => ({
  type: 'UPDATE_PERMISSIONS',
  payload: {
    permissions,
    token
  },
});

export const getAdmins = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_ADMINS',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const updateAdmins = (admins, token) => ({
  type: 'UPDATE_ADMINS',
  payload: {
    admins,
    token
  },
});

export const showRollOutsPay = (orderIds, token) => ({
  type: 'GET_ROLL_OUTS_PAY_ORDER',
  payload: {
    orderIds,
    token,
  },
});

export const getReconciliationRollRecord = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_RECONCILIATION_ROLL_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getReconciliationRollCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_RECONCILIATION_ROLL_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const deductRoll = (userId,amount,region,deductNote,deductType, token) => ({
  type: 'DEDUCT_ROLL',
  payload: {
    userId,
    amount,
    region,
    deductType,
    deductNote,
    token,
  },
});

export const revokeDeduct = (orderId,deductType, token) => ({
  type: 'REVOKE_DEDUCT',
  payload: {
    orderId,
    deductType,
    token,
  },
});

export const getUserVisitRecord = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_VISIT_RECORD',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollInRecordLast = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_IN_LIST_LAST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKWarnRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_WARN_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKBlacklistRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_BLACKLIST_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const deleteCDKWarn = (warnId, token) => ({
  type: 'DELETE_CDK_WARN',
  payload: {
    warnId,
    token,
  },
});

export const blackoutCDKWarn = (warnId,userId,reason,token) => ({
  type: 'BLACKOUT_CDK_WARN',
  payload: {
    warnId,
    userId,
    reason,
    token,
  },
});

export const deleteCDKBlacklist = (blacklistId,reason, token) => ({
  type: 'DELETE_CDK_BLACKLIST',
  payload: {
    blacklistId,
    reason,
    token,
  },
});

export const getCDKDisputeRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_DISPUTE_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getRollOutRecordAdminCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_USER_ROLL_OUT_RECORD_ADMIN_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKReviewRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_REVIEW_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKRefundRecords = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_REFUND_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKRefundRecordsCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_REFUND_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getCDKDisputeRecordsCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_CDK_DISPUTE_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getTip = (token) => ({
  type: 'GET_TIP',
  payload: {
    token,
  },
});

export const getAdminTwitchDropListByGame = (gameId, token) => ({
  type: 'GET_ADMIN_TWITCH_DROP_LIST_BY_GAME',
  payload: {
    gameId,
    token,
  },
});

export const createSaleProduct = (productName,productPlatform,productType,productPrice,productCommission,productCover,productDescription,productStatus, token) => ({
  type: 'CREATE_SALE_PRODUCT',
  payload: {
    productName,
    productPlatform,
    productPrice,
    productCommission,
    productCover,
    productDescription,
    productStatus,
    productType,
    token,
  },
});

export const uploadSaleProductCDKeys = (multipartFormData, productId,isIgon,platform, token) => ({
  type: 'UPLOAD_SALE_PRODUCT_CD_KEYS',
  payload: {
    multipartFormData,
    productId,
    platform,
    isIgon,
    token,
  },
});

export const getSaleProducts = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_SALE_PRODUCTS',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const setSaleProductStatus = (projectId, token) => ({
  type: 'SET_SALE_PRODUCT_STATUS',
  payload: {
    projectId,
    token,
  },
});

export const updateSaleProductSetting = (setting, token) => ({
  type: 'UPDATE_SALE_PRODUCT_SETTING',
  payload: {
    setting,
    token,
  },
});

export const updateSaleProduct = (productId, product, token) => ({
  type: 'UPDATE_SALE_PRODUCT',
  payload: {
    productId,
    product,
    token,
  },
});

export const getASaleProductOrders = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_ADMIN_SALE_PRODUCT_ORDER_LIST',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});

export const getSaleProductOrderStatis = (token) => ({
  type: 'GET_SALE_PRODUCT_ORDER_STATIS',
  payload: {
    token,
  },
});

export const getSaleProductOrderRank = (filter,token) => ({
  type: 'GET_SALE_PRODUCT_ORDER_RANK',
  payload: {
    filter,
    token,
  },
});

export const getASaleProductOrdersCsv = (pageNum,search, filter, sorting, token, exactMatch) => ({
  type: 'GET_ADMIN_SALE_PRODUCT_ORDER_CSV',
  payload: {
    pageNum,
    search,
    filter,
    sorting,
    token,
    exactMatch,
  },
});
export const approveUserWalletError = (errorUserId,region, token) => ({
  type: 'APPROVE_USER_WALLET_ERROR',
  payload: {
    errorUserId,
    region,
    token,
  },
});

export const approveUserRollInError = (errorOrderId,region, token) => ({
  type: 'APPROVE_USER_ROLLIN_ERROR',
  payload: {
    errorOrderId,
    region,
    token,
  },
});

export const getAnnouncementList = token => ({
  type: 'GET_ANNOUNCEMENT_LIST',
  payload: { token },
});

export const createAnnouncement = (announcement, token) => ({
  type: 'CREATE_ANNOUNCEMENT',
  payload: { announcement, token },
});

export const updateAnnouncement = (id, announcement, token) => ({
  type: 'UPDATE_ANNOUNCEMENT',
  payload: { id, announcement, token },
});
